import { Injectable } from '@jkhy/frontend-utils/di';
import { NavigationModelDto, NavigationsClient, WiresClient } from '@treasury/api/channel';

const WIRES_FX_NAV_KEY = 'createFXWire';

@Injectable()
export class CorpayService {
    constructor(
        private readonly wiresClient: WiresClient,
        private readonly navigationsClient: NavigationsClient
    ) {}

    public async getSsoUrl(): Promise<string> {
        const response = await this.wiresClient.wiresGetCorpaySsoLogin();
        const url = response.data?.content;

        if (!url) {
            throw new Error('Invalid response from Corpay SSO endpoint.');
        }

        return url;
    }

    public async hasSsoUniqueId(): Promise<boolean> {
        const response = await this.navigationsClient.navigationsGetNavigationsWithSso();
        const wiresFxItem = this.findNavItem(response.data ?? [], WIRES_FX_NAV_KEY);
        return !!wiresFxItem?.ssoUniqueId;
    }

    private findNavItem(items: NavigationModelDto[], key: string): NavigationModelDto | undefined {
        for (const item of items) {
            if (item.key === key) {
                return item;
            }
            if (item.subMenus?.length) {
                const found = this.findNavItem(item.subMenus, key);
                if (found) {
                    return found;
                }
            }
        }
        return undefined;
    }
}
